/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrgenerate1Inputs */

const en_qrgenerate1 = /** @type {(inputs: Qrgenerate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate QR code`)
};

const de_qrgenerate1 = /** @type {(inputs: Qrgenerate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-Code erstellen`)
};

/**
* | output |
* | --- |
* | "Generate QR code" |
*
* @param {Qrgenerate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrgenerate1 = /** @type {((inputs?: Qrgenerate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrgenerate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrgenerate1(inputs)
	return de_qrgenerate1(inputs)
});
export { qrgenerate1 as "qrGenerate" }